import { Button, Card, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { AuthHeader } from '../../../utils/helpers/auth-headers';
import { bytesToSize, Worker } from '../../../models/Worker';
import { Alarm } from '../../../models/Alarm';

function WorkerDetails() {
  const { t } = useTranslation();
  const i18nLang = i18next.language;
  const paramsUrl = useParams();
  const [worker, setWorker] = useState<Worker>();
  const navigate = useNavigate();
  const paramsRoute = useParams();
  const path = useLocation().pathname;
  const [alarms, setAlarms] = useState<Alarm[]>([]);

  function getWorkers(instanceId: string) {
    return axios.get(`${window._env_.REACT_APP_API_URI}/pexipInstance/${instanceId}/workers`, { headers: AuthHeader() ? { Authorization: `Bearer ${AuthHeader()}` } : {} });
  }

  const cancelDetails = () => {
    const url = `/instance/${paramsUrl.instanceId}/configuration`;
    navigate(url);
  };

  const getAlarms = (w: Worker) => {
    axios.get(`${window._env_.REACT_APP_API_URI}/pexipInstance/${paramsRoute.instanceId}/alarms`, { headers: AuthHeader() ? { Authorization: `Bearer ${AuthHeader()}` } : {} })
      .then((response) => {
        setAlarms(response.data.data.filter((el: Alarm) => el.node === w.address));
      })
      .catch((error) => {
        if (error.response) {
          const err = error.response;
          console.error(err);
        }
        console.error(error);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      if (paramsUrl.instanceId && paramsUrl.workerId) {
        let workers = [];
        workers = await (await getWorkers(paramsUrl.instanceId)).data.data;
        for (const w of workers) {
          if (w.id.toString() === paramsUrl.workerId) {
            setWorker(w);
            getAlarms(w);
          }
        }
      }
    };
    fetchData().catch(console.error);
  }, [path]);

  return ( 
    <div>
      {worker ? (
        <div>
          <Card className="worker-details">
            <div className="card-title">{worker.name}</div>
            { alarms?.length > 0 && (
              <div>
                <div><strong>{t('InstanceConfiguration.worker.alarms')} :</strong></div>
                { alarms.map((alarm: any) => (
                  <div key={alarm.id} className="alarm-item">
                    <Grid container spacing={2} columns={12}>
                      <Grid item xs={6}>
                        <div>
                          <strong>{t('InstanceAlarms.table.name')} : </strong>
                          <span className={alarm.level === 'warning' ? 'is-warning' : 'is-invalid'}>{alarm.name}</span>
                        </div>
                        <div>
                          <strong>{t('InstanceAlarms.table.details')} : </strong>
                          <span className={alarm.level === 'warning' ? 'is-warning' : 'is-invalid'}>{alarm.details}</span>
                        </div>
                        <div>
                          <strong>{t('InstanceAlarms.table.instance')} : </strong>
                          {alarm.instance}
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div>
                          <strong>{t('InstanceAlarms.table.timeRaised')} : </strong>
                          {new Date(alarm.timeRaised).toLocaleString(i18nLang)}
                        </div>
                        <div>
                          <strong>{t('InstanceAlarms.table.identifier')} : </strong>
                          {alarm.identifier}
                        </div>
                        <div>
                          <strong>{t('InstanceAlarms.table.resourceUri')} : </strong>
                          {alarm.resourceUri}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                ))}
                <hr />
              </div> 
            )}
            <Grid container spacing={2} columns={12}>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.configurationId')} : </strong>
                  {worker.configurationId}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.systemLocation')} : </strong>
                  {worker.systemLocation}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.nodeType')} : </strong>
                  {worker.nodeType}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.syncStatus')} : </strong>
                  {worker.syncStatus === 'SYNCED' ? (<span className="is-valid">{worker.syncStatus}</span>) : (<span className="is-invalid">{worker.syncStatus}</span>)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.maintenanceMode')} : </strong>
                  {worker.maintenanceMode ? (<span>{t('InstanceConfiguration.worker.yes')}</span>) : (<span>{t('InstanceConfiguration.worker.no')}</span>)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.deployStatus')} : </strong>
                  {worker.deployStatus}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.upgradeStatus')} : </strong>
                  {worker.upgradeStatus}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.version')} : </strong>
                  {worker.version}
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.resourceUri')} : </strong>
                  {worker.resourceUri}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.cloudBursting')} : </strong>
                  {worker.cloudBursting ? (<span>{t('InstanceConfiguration.worker.yes')}</span>) : (<span>{t('InstanceConfiguration.worker.no')}</span>)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.enableDistributedDatabase')} : </strong>
                  {worker.enableDistributedDatabase ? (<span>{t('InstanceConfiguration.worker.yes')}</span>) : (<span>{t('InstanceConfiguration.worker.no')}</span>)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.managed')} : </strong>
                  {worker.managed ? (<span>{t('InstanceConfiguration.worker.yes')}</span>) : (<span>{t('InstanceConfiguration.worker.no')}</span>)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.serviceManager')} : </strong>
                  {worker.serviceManager ? (<span>{t('InstanceConfiguration.worker.yes')}</span>) : (<span>{t('InstanceConfiguration.worker.no')}</span>)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.servicePolicy')} : </strong>
                  {worker.servicePolicy ? (<span>{t('InstanceConfiguration.worker.yes')}</span>) : (<span>{t('InstanceConfiguration.worker.no')}</span>)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.signalling')} : </strong>
                  {worker.signalling ? (<span>{t('InstanceConfiguration.worker.yes')}</span>) : (<span>{t('InstanceConfiguration.worker.no')}</span>)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.transcoding')} : </strong>
                  {worker.transcoding ? (<span>{t('InstanceConfiguration.worker.yes')}</span>) : (<span>{t('InstanceConfiguration.worker.no')}</span>)}
                </div>
              </Grid>
            </Grid>
            <hr />
            <Grid container spacing={2} columns={12}>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.cpuCapabilities')} : </strong>
                  {worker.cpuCapabilities}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.cpuCount')} : </strong>
                  {worker.cpuCount}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.cpuModel')} : </strong>
                  {worker.cpuModel}
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.totalRam')} : </strong>
                  {bytesToSize(worker.totalRam)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.hypervisor')} : </strong>
                  {worker.hypervisor}
                </div>
              </Grid>
            </Grid>
            <hr />
            <Grid container spacing={2} columns={12}>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.bootTime')} : </strong>
                  {new Date(worker.bootTime).toLocaleString(i18nLang)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.lastAttemptedContact')} : </strong>
                  {new Date(worker.lastAttemptedContact).toLocaleString(i18nLang)}
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.lastReported')} : </strong>
                  {new Date(worker.lastReported).toLocaleString(i18nLang)}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.lastUpdated')} : </strong>
                  {new Date(worker.lastUpdated).toLocaleString(i18nLang)}
                </div>
              </Grid>
            </Grid>
            <hr />
            <Grid container spacing={2} columns={12}>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.maxAudioCalls')} : </strong>
                  {worker.maxAudioCalls}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.maxFullHdCalls')} : </strong>
                  {worker.maxFullHdCalls}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.maxHdCalls')} : </strong>
                  {worker.maxHdCalls}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.maxMediaTokens')} : </strong>
                  {worker.maxMediaTokens}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.maxSdCalls')} : </strong>
                  {worker.maxSdCalls}
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.mediaTokensUsed')} : </strong>
                  {worker.mediaTokensUsed}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.mediaLoad')} : </strong>
                  {worker.mediaLoad}%
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.signalingCount')} : </strong>
                  {worker.signalingCount}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.mediaPriorityWeight')} : </strong>
                  {worker.mediaPriorityWeight}
                </div>
              </Grid>
            </Grid>  
            <hr />
            <Grid container spacing={2} columns={12}>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.domain')} : </strong>
                  {worker.domain}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.hostname')} : </strong>
                  {worker.hostname}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.alternativeFqdn')} : </strong>
                  {worker.alternativeFqdn}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.netmask')} : </strong>
                  {worker.netmask}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.secondaryAddress')} : </strong>
                  {worker.secondaryAddress}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.secondaryNetmask')} : </strong>
                  {worker.secondaryNetmask}
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.enableSsh')} : </strong>
                  {worker.enableSsh}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.gateway')} : </strong>
                  {worker.gateway}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.hostname')} : </strong>
                  {worker.hostname}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.ipv6Address')} : </strong>
                  {worker.ipv6Address}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.ipv6Gateway')} : </strong>
                  {worker.ipv6Gateway}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.staticNatAddress')} : </strong>
                  {worker.staticNatAddress}
                </div>
              </Grid>
            </Grid>
            <hr />
            <Grid container spacing={2} columns={12}>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.snmpCommunity')} : </strong>
                  {worker.snmpCommunity}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.snmpMode')} : </strong>
                  {worker.snmpMode}
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <strong>{t('InstanceConfiguration.worker.snmpSystemContact')} : </strong>
                  {worker.snmpSystemContact}
                </div>
                <div>
                  <strong>{t('InstanceConfiguration.worker.snmpSystemLocation')} : </strong>
                  {worker.snmpSystemLocation}
                </div>
              </Grid>
            </Grid>
            <div style={{ padding: 10 }}>
              <Button fullWidth onClick={cancelDetails} variant="outlined">{t('WorkerDetails.button.back')}</Button>
            </div>
          </Card>
        </div>
      ) : (
        <div>No Worker :(</div>
      )}
    </div>
  );
}

export default WorkerDetails;
